/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Smb_Root_Path_LabelInputs */



/**
* | output |
* | --- |
* | "Root path" |
*
* @param {Spaces_Smb_Root_Path_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_smb_root_path_label = /** @type {((inputs?: Spaces_Smb_Root_Path_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Smb_Root_Path_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Stammverzeichnis")
	return /** @type {LocalizedString} */ ("Root path")
});